
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[companySlug]/customer-portal",
      function () {
        return require("private-next-pages/[companySlug]/customer-portal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[companySlug]/customer-portal"])
      });
    }
  